/* The deck readout: speed, pitch and a level meter. */

.readout {
  position: absolute;
  right: calc(14px + var(--safe-r));
  bottom: calc(120px + var(--safe-b));
  width: 132px;
  border-radius: var(--r-md);
  padding: 10px 12px;
  display: grid;
  gap: 5px;
}

.row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}

.key {
  font-size: 9.5px;
  font-weight: 700;
  letter-spacing: 0.09em;
  color: var(--ink-3);
}

.value {
  font-size: 13px;
  font-weight: 650;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.01em;
}

.meter {
  height: 4px;
  border-radius: 999px;
  background: rgba(11, 31, 23, 0.1);
  overflow: hidden;
  margin-top: 3px;
}

.meterFill {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, var(--accent), #7bd6a5);
  transition: width 0.08s linear;
}

@media (max-width: 620px) {
  .readout {
    display: none;
  }
}

@media (max-height: 460px) and (orientation: landscape) {
  .readout {
    display: none;
  }
}
